import React, { useEffect } from 'react';

import {
  useToast,
} from '@chakra-ui/react';
import {
  Redirect as RedirectDom,
} from 'react-router-dom';

export function Redirect({ to }) {
  const toast = useToast();

  useEffect(() => {
    toast({
      title: 'Acesso negado!',
      description: 'Você precisa estar logado para acessar a plataforma!',
      status: 'info',
      duration: 5000,
      position: 'top-right',
      isClosable: true,
    });
  },
  []);

  return <RedirectDom to={to} />;
}
